// extracted by mini-css-extract-plugin
export default {"documents":"styles_documents__vPpTq","title":"styles_title__Z95X1","disclaimer":"styles_disclaimer__kIcE2"};